module.exports = __webpack_public_path__ + "media/vectors/term-bg-1-666de2d9.jpg";